<template>
  <div class="header w_1200">
    <div class="header_top">
      <div class="header_top_main">
        <div class="header_content">
          <div class="logo" @click="goHome()">
            <img src="~@/assets/img/logo.png" alt="" />
          </div>
          <div class="code-img--list">
            <img src="~@/assets/img/bg.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="bg2">
      <img src="~@/assets/img/bg2.png" alt="" />
    </div>
    <div class="bottom">
      <div class="box" @click="goOther">
        <img src="~@/assets/img/icon1.png" alt="" />
        <p>综合素质评价</p>
      </div>
      <div class="box" @click="goOther">
        <img src="~@/assets/img/icon2.png" alt="" />
        <p>综合素质课程</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { publicPreviewImg } from "@/apis/home";
import { onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
let keyWord = ref(null);
const props = defineProps({
  menus: {
    type: Object,
    default: {},
  },
  topPic: {
    type: Object,
    default: {},
  },
  alerts: {
    type: Array,
    default: () => [],
  },
  notice: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();
const route = useRoute();

const goHome = () => {
  router.push({ path: "/" });
};
const goOther = () => {
  window.open("https://yjszhsz.scu.edu.cn/");
};
const goSearch = () => {
  if (keyWord.value) {
    router.push({ path: "/list/news/ ", query: { keyWord: keyWord.value } });
  } else {
    ElMessage.error("请输入查询关键字");
  }
};
const goDetail = (item: any) => {
  if (
    item.menuUrl.substr(0, 4) == "http" ||
    item.menuUrl.substr(0, 2) == "//"
  ) {
    window.open(item.menuUrl);
  } else {
    router.push({
      path: item.menuUrl,
      query: { uuid: item.uuid },
    });
  }
};

const godetail = (item: any) => {
  if (item.newsType === 2) {
    window.open(item.redUrl);
  } else {
    router.push({
      path: "/infoShow/" + item.nodeNum,
      query: { uuid: item.uuid },
    });
  }
};

onMounted(() => {});
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  min-height: 832px;
}
.bannerImg {
  width: 100%;
  height: 628px;
  position: absolute;
  top: 204px;
  z-index: -1;
}
.header_top {
  height: 130px;
}
.header_top_main {
  height: 130px;
  text-align: center;
}
.header_content {
  height: 124px;
  // margin-bottom: 9px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: #fff;
  .code-img--list {
    display: flex;
    height: 100%;
    .code-img {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #fff;
      margin-right: 20px;
      img {
        width: 80px;
      }
    }
  }
}
.logo {
  // width: 475px;
  height: auto;
  margin-top: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  .box {
    margin: 16px 46px;
    border: 1px solid #4444;
    width: 225px;
    height: 158px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    cursor: pointer;
    p {
      margin-top: 10px;
    }
  }
}
</style>
